import { Injectable, signal } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { IBaseModel } from '../models/base.model';
import { IUserProfileModel, IUserStatusModel } from '../models/user.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom } from 'rxjs';
import { Utils } from '../shared/utils';

@Injectable()
export class AuthService extends BaseService {
    controllerRoute = 'User';

    $user = signal(null as IUserProfileModel);

    constructor(
        httpClient: HttpClient,
        private spinner: NgxSpinnerService,
    ) {
        super(httpClient);
    }

    public async getUserProfile(showLoading = false): Promise<IBaseModel<IUserProfileModel>> {
        if (this.$user() != null) {
            return Promise.resolve({ isSuccess: true, data: this.$user() } as IBaseModel<IUserProfileModel>);
        } else {
            try {
                if (showLoading) {
                    this.spinner.show('root');
                }

                const response = await firstValueFrom(this.httpClient.get<IBaseModel<IUserProfileModel>>(`${this.apiBaseUrl}/${this.controllerRoute}/Profile`));
                Utils.setSignal(this.$user, response.data);
                return response;
            } catch (error) {
                this.$user.set(null);
                throw (error);
            } finally {
                this.spinner.hide('root');
            }
        }
    }

    public async getStatus(): Promise<IBaseModel<IUserStatusModel>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<IUserStatusModel>>(`${this.apiBaseUrl}/${this.controllerRoute}/Status`));
    }

    public async logout(ignoreEndSession?: boolean) {
        return await firstValueFrom(this.httpClient.get(`/Account/Logout${ignoreEndSession ? '?ignoreEndSession=true' : ''}`));
    }

    public login() {
        window.location.replace('/Account/Login?returnUrl=' + window.location.href);
    }

    public hasProfiles(profiles: string[]) {
        return this.$user()
            && this.$user().perfis
            && profiles.some(p => this.$user().perfis.indexOf(p) >= 0);
    }
}
